import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";

const faqs = [
  { q: "Am I eligible for Mounjaro / Tirzepatide?", a: "Typically adults with BMI ≥ 27 with weight‑related conditions or BMI ≥ 30 are evaluated. Final eligibility is decided by Dr. Shalini after a clinical review and basic labs." },
  { q: "Is it safe? What about side effects?", a: "When prescribed and titrated by an endocrinologist, GLP‑1 therapies have a strong safety record. Mild nausea or fullness in the first few weeks is common and usually settles within 2–3 weeks." },
  { q: "Will I regain weight after stopping?", a: "Mounjaro is one tool. We pair it with sustainable nutrition, sleep and movement habits so weight stays off after a structured taper." },
  { q: "What is the cost of the programme?", a: "Cost depends on dose strength and duration. We share a transparent quote after the eligibility consultation — no hidden fees, ever." },
  { q: "Do you treat patients from other cities in Telangana & Andhra Pradesh?", a: "Yes. Patients visit the Madinaguda clinic from across Hyderabad — Miyapur, KPHB, Kondapur, Madhapur, Gachibowli, Kukatpally, Hitech City, Jubilee Hills. For Warangal, Karimnagar, Nizamabad, Khammam, Visakhapatnam, Vijayawada, Guntur, Tirupati, Kurnool, Nellore, Rajahmundry and other Telangana/AP districts, Dr. Shalini offers secure online video consultations with cold‑chain medication delivery." },
  { q: "Do you offer online consultations?", a: "Yes. Initial and follow‑up consultations are available online for patients across Telangana, Andhra Pradesh and anywhere in India. Medication is delivered cold‑chain to your door." },
  { q: "Is Mounjaro available in India?", a: "Mounjaro (Tirzepatide) is launched in India by Eli Lilly. We source only genuine supply with proper cold‑chain handling." },
];

export const FAQ = () => {
  return (
    <section id="faq" className="py-24 md:py-32 bg-white">
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-[#E8F0E9] px-3.5 py-1.5 text-xs font-semibold text-[#779D7C]">
          Frequently asked
        </span>
        <h2 className="mt-5 font-display text-4xl md:text-5xl leading-[1.05] text-[#242220]">
          Everything you want to know, <em className="text-[#EB8771]">clearly answered</em>.
        </h2>

        <Accordion type="single" collapsible className="mt-12 text-left" data-testid="faq-accordion">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-b border-[#EAE7E1]">
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left font-display text-xl md:text-2xl text-[#242220] hover:no-underline py-6"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#38312C] text-base leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
